<template>
  <div>
    <div>
      <b-breadcrumb
        style="
          background-color: #002b4954 !important;
          padding: 0.45rem 1rem !important;
          margin-bottom: 3px !important;
        "
      >
        <b-breadcrumb-item active>
          <i :class="iconId"></i>
          {{ jobSeriesBanner }}
        </b-breadcrumb-item>
        <b-breadcrumb-item active>
          <i class="fa fa-user"></i> {{ bannerClientName }}</b-breadcrumb-item
        >
        <b-breadcrumb-item @click="loadSummaryDoc"
          ><b-badge style="font-size: 100%">
            Summary & Documents</b-badge
          ></b-breadcrumb-item
        >
         <Add-Message class='ml-auto' :fk_all_module_id="allModuleIdBanner"/>
         <BRFCard
            v-if="prbr_id"
            :BRFDetails="null"
            :prbr_id="Number(prbr_id)"
          />
      </b-breadcrumb>
    </div>
    <div>
      <b-modal
        size="xl"
        id="doc"
        class="modal-dialog-doc"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        :title="'Assignment Summary & Documents - ' + jobSeriesBanner"
      >
        <div v-if="allModuleIdBanner && showSummary == true">
          <doc-form
            :allModuleIdProp="allModuleIdBanner"
            :JOBSERIES="jobSeriesBanner"
          />
        </div>
        <b-button
          class="mt-3"
          variant="outline-danger"
          block
          @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import DocForm from "../allModuleForm/docLibrary.vue";
import { URL_BASE, URL_BASE_DOC, URL_NODE_BASE } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../helper/collection";
import AddMessage from "../allModuleForm/addMessage.vue";
import BRFCard from "../common/brfCard.vue";
import CommonService from "../../services/CommonService.js";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";

export default {
  props: ["allModuleIdBanner", "jobSeriesBanner", "bannerClientName", "iconId","prbr_id"],
  beforeMount() {
    if(this.allModuleIdBanner){
      this.getBRFData();
    }
    if (this.DOCNAME) {
      // this.getData();
    } else {
      // this.$router.push({
      //   path: "/dashboard",
      // });
    }
  },

  data() {
    return {
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      isLoading: false,
      showSummary: false,
      docArray: [],
      showSumaryArray: [],
      doc_master: [],
      docURL: URL_BASE_DOC,
      brf_id:null,

      singleUpload: null,
      singleUpload: null,
      showAdd: true,

      allModuleId: this.allModuleIdProp,
    };
  },
  //this.$route.params.moduleId?this.$route.params.moduleId:
  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
    DocForm,
    AddMessage,
    BRFCard,
  },

  computed: {},
  //  watch: {
  //    JOBSERIES : {
  //       handler: function(newVal, oldVal) {
  //        this.getData()
  //       },
  //       deep: true
  //     },
  //  },
  methods: {
    loadSummaryDoc() {
      this.showSummary = true;
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.showSummary = false;
      this.$refs["doc-modal"].hide();
    },
    downloadZip() {
      console.log(this.DOCNAME);
      let payload = {
        upload_dir_folderName: this.jobSeriesBanner.replaceAll("/", "_"),
      };
      NodeLockPannelService.downloadAssignmentZipNode(payload)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${payload.upload_dir_folderName}.zip`);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.error("Download Error:", error);
        });
    },

    getBRFData() {
     
      let payload = {
        itemCode:'getBRFData',
        allModuleId: this.allModuleIdBanner,
      };

      CommonService.getAllJobList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data.getPRBRFLAG == 1) {
            if (!isNaN(data.prbr_id) && data.prbr_id > 0) {
            this.brf_id = Number(data.prbr_id);
          }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getBRFData Error: ", error);
        });
    },

    getData() {
      let splitAssignMentId = "";
      if (this.jobSeriesBanner) {
        let abc = this.jobSeriesBanner.split("/");
        if (abc.length > 0) {
          splitAssignMentId = abc[5];
        }
      }
      this.showAdd = true;
      //this.isLoading=true
      this.docArray = [];
      this.showSumaryArray = [];
      let payload = {
        allModuleId: this.allModuleIdProp,
        splitAssignMentId: splitAssignMentId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/getAllDocs.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data, "iuyiu");

            if (data.docArray.length > 0) {
              this.docArray = data.docArray;
            }

            if (data.doc_master.length > 0) {
              this.doc_master = data.doc_master;
            }
            if (data.mainExecData.length > 0) {
              if (
                data.mainExecData[0].transportType == "Export" &&
                data.mainExecData[0].shipmentType == "1"
              ) {
                var p = data.FFSumary[0];
                for (var key in p) {
                  if (p.hasOwnProperty(key)) {
                    let obj = {
                      name: key,
                      value: p[key] ? p[key] : "--",
                    };
                    this.showSumaryArray.push(obj);
                  }
                }
                var q = data.CCSumary[0];
                for (var key in q) {
                  if (
                    q.hasOwnProperty(key) &&
                    !this.showSumaryArray.hasOwnProperty(key)
                  ) {
                    let obj = {
                      name: key,
                      value: q[key] ? q[key] : "--",
                    };
                    this.showSumaryArray.push(obj);
                  }
                }
                function getUniqueListBy(arr, key) {
                  return [
                    ...new Map(arr.map((item) => [item[key], item])).values(),
                  ];
                }
                this.showSumaryArray = getUniqueListBy(
                  this.showSumaryArray,
                  "name"
                );
                console.log(this.showSumaryArray, "iuy");
              }
            }
            //this.isLoading=false
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// bannerComponent.vue?18c46154